import { createContext } from 'react';

export type CourseLanguageContextValue = {
  courseLang: string;
  setCourseLang: (lang: string) => void;
};

export const CourseLanguageContext = createContext<CourseLanguageContextValue>({
  courseLang: 'en',
  setCourseLang: () => {},
});
